import React from 'react';
import withTranslations from '../../../utils/HighOrderComponent';
import AttachmentRow from './AttachmentRow';
import { Table } from 'react-bootstrap';

const AttachmentTable = (props) => {
  const {
    attachments,
    t,
    handleDownload,
    controllerReference,
    signal,
    handleDeleteDocument,
  } = props || {};
  const files = attachments?.map((attachment, index) => (
    <AttachmentRow
      key={`attachment_${attachment.id}_${index}`}
      attachment={attachment}
      handleDownload={handleDownload}
      controllerReference={controllerReference}
      signal={signal}
      handleDelete={handleDeleteDocument}
    />
  ));

  return (
    <Table responsive hover id="table" className="table table-sm">
      <thead>
        <tr className="text-center">
          <th className="text-left">{signal ? t.nameUploaded : t.name}</th>
          <th width="16%">{t.preview}</th>
          {!signal && <th width="19%">{t.download}</th>}
          {!!signal && <th width="16%">{t.delete}</th>}
        </tr>
      </thead>
      <tbody>{files}</tbody>
    </Table>
  );
};
export default withTranslations(AttachmentTable, 'AttachmentTable');
